module.exports = __webpack_public_path__ + "static/media/magGlass.fae5a215.jpg";